import { resendConfirmationEmail } from '@develop/ia-api-library'
import { useRecaptcha } from '../recaptcha'

export const useVerification = ({ recaptchaKey, apiKey }: {
  recaptchaKey?: string
  apiKey?: string
}) => {
  const userStore = useUserStore()

  const resendVerificationEmail = async () => {
    let recaptchaResponse

    if (recaptchaKey) {
      const captcha = useRecaptcha(recaptchaKey)
      recaptchaResponse = await captcha.resolve()
    }

    if (!userStore.user?.email)
      return

    if (!apiKey) {
      return resendConfirmationEmail({
        email: userStore.user?.email,
        recaptchaResponse,
      })
    }

    return resendConfirmationEmail({
      email: userStore.user?.email,
      recaptchaResponse,
    }, {
      headers: { apiKey },
    })
  }

  return {
    resendVerificationEmail,
  }
}
